import { Component, OnInit ,HostListener,OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
  `
})
export class AppRootComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}
}

@Component({
  selector: 'app-base',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'zappyhire';
  selectedDate;

//   @HostListener("window:beforeunload",["$event"])
//   clearLocalStorage(event){
//       localStorage.clear();
//   }
//   ngOnDestroy() { 
//     alert("KKk");
//     localStorage.clear();
// }



@HostListener('input', ['$event'])
onKeyDown(event: KeyboardEvent) {
  const input = event.target as HTMLInputElement;

let a:any=input.value;
if(a.indexOf('<script>')===-1)
{

}else{input.value=''}
// var k,c:any=event.key;
// //k = c.charCode;
// if(c!=='<'&&c!=='>')
// {
// alert(c)
//   return (c);}
//   }
}
}
